import * as XLSX from 'xlsx';

export interface PremiumLicenseExportItem {
  license: string;
  isRegistered: boolean;
  createdAt?: string;
}

export interface PremiumLicenseExportGroup {
  role: string;
  licenseNumbers: PremiumLicenseExportItem[];
}

/**
 * API가 내려주는 'YYYY-MM-DD HH:mm:ss' 문자열에서 'YYYY-MM-DD HH:mm'까지만 잘라 반환.
 * ISO 8601이 아니므로 new Date() 파싱은 브라우저별로 결과가 갈릴 수 있어 사용하지 않음.
 * 형식이 어긋나면 원문을 그대로 반환(데이터 손실 방지).
 */
const formatCreatedAt = (raw?: string): string => {
  if (!raw) return '';
  const match = raw.match(/^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2})(?::\d{2})?$/);
  return match ? `${match[1]} ${match[2]}` : raw;
};

const toRow = (role: string, item: PremiumLicenseExportItem) => ({
  '지역': role,
  '면허번호': item.license,
  '가입여부': item.isRegistered ? '가입' : '미가입',
  '생성일': formatCreatedAt(item.createdAt),
});

const COLS = [
  { wch: 28 }, // 지역
  { wch: 14 }, // 면허번호
  { wch: 10 }, // 가입여부
  { wch: 18 }, // 생성일
];

const todayISO = (): string => new Date().toISOString().split('T')[0];

const sanitizeFilename = (name: string): string =>
  name.replace(/[\\/:*?"<>|]/g, '_');

/** 단일 지역 다운로드 */
export function exportPremiumLicensesByRegion(group: PremiumLicenseExportGroup): void {
  const rows = group.licenseNumbers.map((item) => toRow(group.role, item));
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(rows);
  worksheet['!cols'] = COLS;
  XLSX.utils.book_append_sheet(workbook, worksheet, '면허목록');
  XLSX.writeFile(
    workbook,
    `프리미엄면허_${sanitizeFilename(group.role)}_${todayISO()}.xlsx`
  );
}

/** 전체 다운로드 */
export function exportAllPremiumLicenses(groups: PremiumLicenseExportGroup[]): void {
  const rows = groups.flatMap((g) =>
    g.licenseNumbers.map((item) => toRow(g.role, item))
  );
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(rows);
  worksheet['!cols'] = COLS;
  XLSX.utils.book_append_sheet(workbook, worksheet, '면허목록');
  XLSX.writeFile(workbook, `프리미엄면허_전체_${todayISO()}.xlsx`);
}
